// convex/lib/config/domains/notifications.ts

import { validatorNotification } from "../../../system/notifications";
import { validatorUsers } from "../../../system/users";
import type { DomainGroup, TableScope } from "../types";

// ============================================================================
// NOTIFICATIONS DOMAIN - Status Values for i18n
// ============================================================================

export const NOTIFICATION_TYPES = [
  "info",
  "warning",
  "error",
  "success",
  "system",
] as const;

export const notificationsDomain: DomainGroup = {
  id: "notifications",
  name: "Notificaciones",
  description: "Sistema de notificaciones",
  icon: "Bell",
  order: 103,
  status: "active",

  // ── Configuración i18n del dominio ────────────────────
  i18n: {
    namespace: "notifications",
    keys: {
      title: "notifications.title",
      description: "notifications.description",
    },
  },

  modules: [
    {
      id: "notifications",
      name: "Notificaciones",
      description: "Centro de notificaciones del sistema",
      icon: "Bell",
      permissions: ["canCreate", "canRead", "canUpdate", "canDelete"],
      routes: ["/settings/notifications"],
      navigation: {
        showInNav: true,
        contexts: ["settings"],
        navOrder: 15,
        status: "active",
      },

      i18n: {
        namespace: "notifications.notifications",
        keys: {
          title: "notifications.notifications.title",
          description: "notifications.notifications.description",
          longDescription: "notifications.notifications.longDescription",
          searchPlaceholder: "notifications.notifications.searchPlaceholder",
          emptyState: "notifications.notifications.emptyState",
          actions: {
            view: "notifications.notifications.actions.view",
          },
        },
        translatableFields: ["title", "message"],
        translatableEnums: [{ field: "type", values: NOTIFICATION_TYPES }],
      },

      tables: [
        {
          tableName: "notifications",
          schema: validatorNotification,
          scope: "company" as TableScope,
          relations: [
            { key: "user", schema: validatorUsers, tableName: "users" },
          ],
          searchFields: ["title", "message", "type"],
          hasStatusIndex: false,
        },
      ],
      readOnlyTables: [
        { tableName: "users" },
        { tableName: "companies" },
        { tableName: "reports" },
        { tableName: "report_executions" },
      ],
    },
  ],
};
